export function SkipLink(props: {label: string, anchor: string}){
  return <a href={props.anchor} className="skip"><span>{props.label}</span></a>;
}